export const MAX_ATTACHMENTS_COUNT = 4;
export const ATTACHMENTS_SIZE = 65;